<template>
  <td-dialog-detail
    :id="unitId"
    v-model="visible"
    title="单位信息"
    v-model:data="formData"
    type="tabs"
    :cols="formCols"
    mode="edit"
    :action="{
      query: detail,
      update: save
    }"
    label-width="120px"
  >
  </td-dialog-detail>
</template>
<script setup>
import { computed, reactive, ref, watch } from 'vue'
import { detail, submit as save } from '../../../api/unitContact'

import useUser from '../../../composables/useUserInfo'

import userCore from './core'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})
const { unitId } = useUser()
const emit = defineEmits(['update:modelValue'])
const formRef = ref(null)
const visible = computed({
  get() {
    return props.modelValue
  },
  set(val) {
    emit('update:modelValue', val)
  }
})

const formData = ref({
  concact: '',
  phone: '',
  email: ''
})
const { cols, formCols } = userCore(formData)

const open = () => {
  initData()
}
</script>
<script>
export default {
  name: 'HeaderToolsUnitother',
  cname: '单位信息',
  icon: 'el-icon-price-tag',
  sort: 9
}
</script>
